import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isLoaded"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ActionsPropType } from './BotpressInteraction.types';
import { actionDispatch } from './BotpressInteraction.utils';
import { asyncSequentialMap } from '../../../../utils/async';
import { classNames } from '../../../../utils/classname';
import { createComponent } from '../../../foundation/services/components';
import useBotpress from '../../hooks/useBotpress';
var propTypes = {
  actions: ActionsPropType.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  triggerAction: PropTypes.oneOf(['onClick', 'onSubmit', 'onMount'])
};
var defaultProps = {
  children: null,
  className: '',
  triggerAction: 'onClick'
};
export default function BotpressInteraction(_ref) {
  var _createComponent;
  var actions = _ref.actions,
    className = _ref.className,
    children = _ref.children,
    triggerAction = _ref.triggerAction;
  var _useBotpress = useBotpress(),
    isLoaded = _useBotpress.isLoaded,
    methods = _objectWithoutProperties(_useBotpress, _excluded);
  var notify = methods.notify;
  function executeActions() {
    return _executeActions.apply(this, arguments);
  }
  function _executeActions() {
    _executeActions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!isLoaded) {
              _context3.next = 3;
              break;
            }
            _context3.next = 3;
            return asyncSequentialMap(actions, function (action) {
              return actionDispatch(methods, action, notify);
            });
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _executeActions.apply(this, arguments);
  }
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(triggerAction === 'onMount')) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return executeActions();
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [isLoaded]);
  if (triggerAction === 'onMount') {
    return createComponent(children, {
      className: classNames(_defineProperty({
        'botpress-interaction': true
      }, className, className))
    });
  }
  return createComponent(children, (_createComponent = {}, _defineProperty(_createComponent, triggerAction, function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var _children$props;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (children !== null && children !== void 0 && (_children$props = children.props) !== null && _children$props !== void 0 && _children$props[triggerAction]) {
              children.props[triggerAction](e);
            }
            _context2.next = 3;
            return executeActions();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()), _defineProperty(_createComponent, "className", classNames(_defineProperty({
    'botpress-interaction': true
  }, className, className))), _createComponent));
}
BotpressInteraction.propTypes = propTypes;
BotpressInteraction.defaultProps = defaultProps;